module.exports = __webpack_public_path__ + "img/gd.64b1a583.svg";